

const TRANSLATIONS_ES_ES = {
    "email_otp.back":"Atrás",
    "email_otp.enter_email_text":"Introduce tu dirección de correo electrónico para recibir un código de un solo uso",
    "email_otp.send_verification_link":"Enviar código de verificación",
    "email_otp.resend_otp_with_timer":"Reenviar código de verificación en",
    "email_otp.text":"Hemos enviado un código de 6 dígitos al correo [email]. Por favor introduce tu código aquí",
    "email_otp.verify":"Verificar",
    "reset_password.set_password":"Establecer tu contraseña",
    "sign_in.or":"o",
    "sign_in.continue_with":"O accede con",
    "sign_in.continue_with_email":"O accede con tu correo electrónico",
    "sign_in.create_without_password":"Crea una cuenta sin contraseña",
    "sign_in.create_with_otp":"Crea una cuenta con un código de acceso de un solo uso",
    "sign_in.login_with_otp":"Inicia sesión con un código de acceso de un solo uso",
    "sign_in.login_without_password":"Iniciar sesión sin contraseña",
    "sign_in.tooltip_text":"Recibirás un código de verificación temporal de un solo uso en tu correo electrónico para acceder a tu cuenta.",
    "sign_up.tooltip_text":"Recibirás un código de verificación temporal de un solo uso en tu correo electrónico para crear tu cuenta.",
    "sign_in.password_updated":"Se ha actualizado la contraseña.",
    "sign_up.create_an_account":"Crea una cuenta",
    "email_otp.resend_otp":"Reenviar el código de un solo uso",
    "sign_up.email_address":"Email",
    "sign_up.password":"Contraseña",
    "sign_in.create_account" : "Crea una cuenta",
    "sign_in.title": "Iniciar Sesión",
    "sign_in.forgot_password" : "¿Olvidó su contraseña?",
    "reset_password.resend_email": "Reenvía Correo Electrónico",
    "reset_password.sent_title": "¡Correo electrónico enviado!",
    "reset_password.rcvResetLink": "Indica tu dirección de email y a continuación te enviaremos un enlace para restablecer la contraseña.",
    "reset_password.submit": "Enviar",
    "reset_password.back_to_login": "Vuelve al inicio de sesión",
    "reset_password.create_new_password": "Para iniciar sesión en la cuenta, cree una nueva contraseña.",
    "forgot_password.emailSent": "Si existe una cuenta para [], se enviará un correo electrónico con un enlace para restablecer la contraseña. ¿Aún no lo has recibido? Solicita un nuevo correo electrónico a continuación.",
    "gdpr.continue": "Continuar",
    "validation.password_validation_heading": "La contraseña debe incluir:",
    "validation.password_length_ui": "Un mínimo de 8 caracteres",
    "validation.password_upper_case_ui": "Una letra mayúscula",
    "validation.password_lower_case_ui": "Una letra minúscula",
    "validation.password_number_ui": "Un dígito",
    "validation.password_symbol_ui": "Un carácter especial",
    "form.gdprconsent": "Al iniciar sesión, aceptas nuestros",
    "form.termsCondition": "Términos y Condiciones",
    "verify_otp.customer_service_center_link": "s/centro-de-servicio-de-atención-al-cliente",
    "activate_user.verification_successful.message": "¡Enhorabuena! Tu cuenta se ha activado.",
    "activate_user.already_verified.message" : "¡Hola de nuevo! Tu cuenta ya se ha verificado.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Rellena los campos obligatorios antes de continuar.",
    "sign_in.invalid_email_error": "Introduce la dirección de correo electrónico con el formato correcto: nombre@dominio.com",
    "sign_in.invalid_credentials_error": "Has introducido un nombre de usuario o una contraseña no válidos. Inténtalo de nuevo.",
    "sign_in.generic_error": "Se ha producido un error. Inténtalo de nuevo.",
    "sign_in.account_unverified_error": "Tu cuenta aún no se ha activado. Busca el enlace de activación en tu correo electrónico o haz clic en «¿Has olvidado tu contraseña?» para restablecer el acceso a la cuenta.",
    "sign_in.max_attempt_error": "Se ha llegado al máximo de intentos. Inténtalo más tarde.",
    "sign_in.social_signin_error": "No se ha podido iniciar sesión a través de una red social (Google/Facebook/Apple). Inténtalo de nuevo o usa otro método de inicio de sesión.",
    "sign_in.social_signin_email_not_present_error": "Acceso fallido. Inténtalo de nuevo o usa otro método de inicio de sesión.",
    "sign_in.guest_user_signin_error": "Parece que ya existe una cuenta registrada con este correo electrónico. Haz clic en «He olvidado mi contraseña» para restablecer el acceso a tu cuenta.",

    "sign_up.mandatory_field_error": "Rellena los campos obligatorios antes de continuar.",
    "sign_up.invalid_email_error": "Introduce una dirección de correo electrónico válida, como nombre@dominio.com",
    "sign_up.password_length_error": "La contraseña debe tener al menos 8 caracteres.",
    "sign_up.email_already_exist_error": "Este correo electrónico ya existe. Usa otra dirección de correo electrónico.",
    "sign_up.generic_error": "Se ha producido un error. Inténtalo de nuevo.",
    "sign_up.password_policy_error": "La contraseña debe incluir: un número, un carácter especial [!#$%&'*+-/=?^_`{|}~.@] y letras mayúsculas y minúsculas.",
    "sign_up.common_password_error": "La contraseña no puede coincidir con tu dirección de correo electrónico.",

    "forgot_password.mandatory_field_error": "Rellena los campos obligatorios antes de continuar.",
    "forgot_password.invalid_email_error": "Introduce la dirección de correo electrónico con el formato correcto: nombre@dominio.com",
    "forgot_password.generic_error": "Se ha producido un error. Inténtalo de nuevo.",

    "reset_password.mandatory_field_error": "Rellena los campos obligatorios antes de continuar.",
    "reset_password.password_history_error": "La nueva contraseña tiene que ser diferente a las cinco contraseñas anteriores.",
    "reset_password.password_length_error": "La contraseña debe tener al menos 8 caracteres.",
    "reset_password.password_policy_error": "La contraseña debe incluir: un número, un carácter especial [!#$%&'*+-/=?^_`{|}~.@] y letras mayúsculas y minúsculas.",
    "reset_password.common_password_error": "La contraseña no puede coincidir con tu dirección de correo electrónico.",
    "reset_password.generic_error": "Se ha producido un error. Inténtalo de nuevo.",

    "email_otp.email_required_error": "Introduce tu dirección de correo electrónico para continuar.",
    "email_otp.invalid_email_error": "Introduce una dirección de correo electrónico válida, como nombre@dominio.com",
    "email_otp.generic_error": "Se ha producido un error. Inténtalo más tarde.",
    "email_otp.invalid_otp_error": "La contraseña de un solo uso o el código de verificación que has introducido no son válidos. Inténtalo de nuevo.",
    "email_otp.resend_otp_error": "No se ha podido volver a enviar la contraseña de un solo uso. Inténtalo más tarde.",
    "email_otp.verify_otp_error": "Se ha producido un error. Vuelve a intentar la verificación con contraseña de un solo uso más tarde.",
    "email_otp.verify_otp_limit_exceed_error": "La contraseña de un solo uso que has introducido no es válida. Haz clic en la opción para volver a enviarla.",
    "email_otp.max_attempt_reached_error": "Se ha llegado al máximo de intentos. Inténtalo más tarde.",
    "email_otp.brute_force_error_part_1": "Tu cuenta se ha bloqueado temporalmente a causa de demasiados intentos de inicio de sesión erróneos. Inténtalo de nuevo más tarde o ",
    "email_otp.brute_force_error_part_2": "ponte en contacto con nuestro Centro de ayuda",
    "email_otp.brute_force_error_part_3": ".",

    //Page Titles
    "sign_in.page_title": "Iniciar sesión | Pens.com",
    "sign_up.page_title": "Registrarse | Pens.com",
    "forgot-password.page_title": "Se te olvidó tu contraseña | Pens.com",
    "reset-password.page_title": "Restablecer la contraseña | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_ES_ES;